import { createStore } from 'stimulus-store';

export const deploymentStatusFilterSelectionStore = createStore({
    name: 'deploymentStatusFilterSelectionStore',
    type: String,
    initialValue: ''
});
